import {HttpServices} from '../Helpers';
import {PHP_V13_URL} from '../api/urls';

export const GetAllSetupsPositions = async ({
    limit,
    page,
    search,
    status = true,
    use_for = 'dropdown',
    hierarchy_uuid,
    with_than,
    other_than,
    check_rules
}) => {
    const queryList = [];
    if (limit || limit === 0) queryList.push(`limit=${limit}`);
    if (page || page === 0) queryList.push(`page=${page}`);
    if (search) queryList.push(`query=${search}`);
    if (status) queryList.push(`status=${status}`);
    if (use_for) queryList.push(`use_for=${use_for}`);
    if (hierarchy_uuid) queryList.push(`reports_to_uuid=${hierarchy_uuid}`);
    if (check_rules) queryList.push(`check_rules=${check_rules}`);
    const result = await HttpServices.get(
        `${PHP_V13_URL}/api/setup/${
            process.env.REACT_APP_VERSION_API
        }/personnel/position?${queryList.join('&')}`,
        {
            params: {with_than, other_than},
        },
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};

export const GetSetupsPositionsDetailsById = async ({uuid}) => {
    const queryList = [];
    if (uuid) queryList.push(`uuid=${uuid}`);

    const result = await HttpServices.get(
        `${PHP_V13_URL}/api/setup/${
            process.env.REACT_APP_VERSION_API
        }/personnel/position/details?${queryList.join('&')}`,
    )
        .then((data) => data)
        .catch((error) => error.response);

    return result;
};
